"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ベトナムへのゲートウェイ() {
  const heroRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const buttonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const deltaX = e.clientX - centerX;
      const deltaY = e.clientY - centerY;
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      const maxDistance = 150;
      if (distance < maxDistance) {
        const strength = 1 - distance / maxDistance;
        setMousePosition({
          x: deltaX * strength * 0.3,
          y: deltaY * strength * 0.3
        });
      } else {
        setMousePosition({
          x: 0,
          y: 0
        });
      }
    }
  };
  const handleMouseLeave = () => {
    setMousePosition({
      x: 0,
      y: 0
    });
  };
  const parallaxOffset = scrollY * 0.1;
  return <section ref={heroRef} className="relative h-screen w-full overflow-hidden bg-dark-background" onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-75 ease-linear bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1411237/img/vietnam_gateway_hero_background.png)]" style={{
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-r from-primary-dark/50 via-primary/20 to-primary-dark/50 animate-[pulse_8s_ease-in-out_infinite]" />

      {}
      <div className="absolute inset-0 bg-primary-dark/30" />

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 md:px-12 lg:px-24">
        {}
        <div className={`max-w-5xl text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0"}`}>
          <h1 className="font-display text-5xl font-bold leading-tight text-foreground-dark md:text-6xl lg:text-7xl xl:text-8xl">
            Your Gateway to the
            <br />
            <span className="bg-gradient-to-r from-accent via-accent-hover to-accent bg-clip-text text-transparent">
              Dynamic Vietnam!
            </span>
          </h1>
          <p className="mt-8 font-sans text-lg leading-relaxed text-foreground-dark/90 md:text-xl lg:text-2xl" style={{
          transitionDelay: "150ms"
        }}>
            Nhật Minh Khang & Partners Co., Ltd. – 専門的なベトナム市場進出支援
          </p>
        </div>

        {}
        <div ref={buttonRef} className="absolute bottom-12 right-12 transition-transform duration-300 ease-[var(--ease-spring)]" style={{
        transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`
      }}>
          <Link to="/Page">
            <Button size="lg" className="group relative overflow-hidden border-2 border-accent bg-primary px-8 py-6 text-base font-semibold text-foreground-primary shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105 hover:bg-primary-hover hover:shadow-[0_0_30px_rgba(255,215,0,0.4)] focus-visible:ring-accent/50 md:px-10 md:py-7 md:text-lg">
              <span className="relative z-10 flex items-center gap-3">
                お問い合わせ
                <ArrowRight className="size-5 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-accent/0 via-accent/20 to-accent/0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>;
}